import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import { InfoKey } from '@/contexts/infoPanel/model/InfoKey.enum.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  infoKey: InfoKey | null;
  isOpen: boolean;
  onClose: () => void;
};

export const InfoPanel: React.FC<Props> = ({ infoKey, isOpen, onClose }) => {
  const { t } = useTranslationWithPrefix('components.infoPanel');

  return (
    <Drawer anchor="right" onClose={onClose} open={isOpen}>
      <Stack
        spacing={3}
        sx={{
          background: 'linear-gradient(180deg, rgba(247,247,248,1) 0%, rgba(255,255,255,1) 100%)',
          height: '100%',
          p: 3,
          width: { sm: 420, xs: 'min(100vw, 420px)' },
        }}
      >
        <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
          <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
            <HelpOutlineOutlinedIcon sx={{ color: themeColors.accentColorDark }} />
            <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
              {infoKey ? t(`entries.${infoKey}.title`) : ''}
            </Typography>
          </Stack>
          <IconButton aria-label={t('closeAriaLabel')} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Divider />
        {infoKey && (
          <Typography sx={{ color: themeColors.greyDark, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
            {t(`entries.${infoKey}.body`)}
          </Typography>
        )}
      </Stack>
    </Drawer>
  );
};
